/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  RejectTradingChallengeRegistrationRequestOptions,
  RejectTradingChallengeRegistrationRequestStatus200,
  RejectTradingChallengeRegistrationRequestStatus400,
  RejectTradingChallengeRegistrationRequestStatus401,
  RejectTradingChallengeRegistrationRequestStatus403,
  RejectTradingChallengeRegistrationRequestStatus404,
  RejectTradingChallengeRegistrationRequestStatus409,
  RejectTradingChallengeRegistrationRequestStatus500,
} from '../types/RejectTradingChallengeRegistrationRequest'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { rejectTradingChallengeRegistrationRequest } from '../clients/rejectTradingChallengeRegistrationRequest'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const rejectTradingChallengeRegistrationRequestMutationKey = () =>
  [{ url: '/v1/trading_challenges/registration_requests/:request_id/reject' }] as const

export function rejectTradingChallengeRegistrationRequestMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = rejectTradingChallengeRegistrationRequestMutationKey()
  return mutationOptions<
    RejectTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | RejectTradingChallengeRegistrationRequestStatus400
      | RejectTradingChallengeRegistrationRequestStatus401
      | RejectTradingChallengeRegistrationRequestStatus403
      | RejectTradingChallengeRegistrationRequestStatus404
      | RejectTradingChallengeRegistrationRequestStatus409
      | RejectTradingChallengeRegistrationRequestStatus500
    >,
    RejectTradingChallengeRegistrationRequestOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return rejectTradingChallengeRegistrationRequest({
        ...config,
        path,
        body,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @description Accessible to admins (any challenge), integrators (their own tenant only) and competition managers (their assigned challenges only).
 * @summary Reject a trading challenge registration request
 * {@link /v1/trading_challenges/registration_requests/:request_id/reject}
 */
export function useRejectTradingChallengeRegistrationRequest<TContext>(
  options: {
    mutation?: UseMutationOptions<
      RejectTradingChallengeRegistrationRequestStatus200,
      ResponseErrorConfig<
        | RejectTradingChallengeRegistrationRequestStatus400
        | RejectTradingChallengeRegistrationRequestStatus401
        | RejectTradingChallengeRegistrationRequestStatus403
        | RejectTradingChallengeRegistrationRequestStatus404
        | RejectTradingChallengeRegistrationRequestStatus409
        | RejectTradingChallengeRegistrationRequestStatus500
      >,
      RejectTradingChallengeRegistrationRequestOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey =
    mutationOptions.mutationKey ?? rejectTradingChallengeRegistrationRequestMutationKey()

  const baseOptions = rejectTradingChallengeRegistrationRequestMutationOptions(
    config,
  ) as UseMutationOptions<
    RejectTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | RejectTradingChallengeRegistrationRequestStatus400
      | RejectTradingChallengeRegistrationRequestStatus401
      | RejectTradingChallengeRegistrationRequestStatus403
      | RejectTradingChallengeRegistrationRequestStatus404
      | RejectTradingChallengeRegistrationRequestStatus409
      | RejectTradingChallengeRegistrationRequestStatus500
    >,
    RejectTradingChallengeRegistrationRequestOptions,
    TContext
  >

  return useMutation<
    RejectTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | RejectTradingChallengeRegistrationRequestStatus400
      | RejectTradingChallengeRegistrationRequestStatus401
      | RejectTradingChallengeRegistrationRequestStatus403
      | RejectTradingChallengeRegistrationRequestStatus404
      | RejectTradingChallengeRegistrationRequestStatus409
      | RejectTradingChallengeRegistrationRequestStatus500
    >,
    RejectTradingChallengeRegistrationRequestOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    RejectTradingChallengeRegistrationRequestStatus200,
    ResponseErrorConfig<
      | RejectTradingChallengeRegistrationRequestStatus400
      | RejectTradingChallengeRegistrationRequestStatus401
      | RejectTradingChallengeRegistrationRequestStatus403
      | RejectTradingChallengeRegistrationRequestStatus404
      | RejectTradingChallengeRegistrationRequestStatus409
      | RejectTradingChallengeRegistrationRequestStatus500
    >,
    RejectTradingChallengeRegistrationRequestOptions,
    TContext
  >
}
